import * as React from 'react';
import { getActiveSupplier } from '../../lib/utils';
import { DataService } from '../../services/DataService';

export interface ISupplierBarProps {
}

export default function SupplierBar (props: ISupplierBarProps) {
  const [supplier, setSupplier] = React.useState("");

  React.useEffect(() => {
    const activeSupplier = getActiveSupplier();
    if(activeSupplier){
      DataService.Suppliers.GetByOrgNr(activeSupplier)
      .then(sup => {
        setSupplier(`${sup.supplierName} - ${sup.supplierOrgNr}`)
      })
    }
  }, []);

  return (
    <>
    {
      supplier &&
      <div className='supplier-bar'>{supplier}</div>
    }
    </>
  );
}
